export const pattern11Data = [
  {
    id: 1,
    koreanChunks: [
      "아는것 마감일이 다가오는거",
      "그녀는",
      "일했다 초과근무를",
      "마무리하기 위해 프로젝트를",
    ],
    englishChunks: [
      "Knowing that the deadline was approaching,",
      "she",
      "worked overtime",
      "to finish the project",
    ],
    fullEnglish:
      "Knowing that the deadline was approaching, she worked overtime to finish the project.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Knowing'은 주절의 동작과 동시에 일어나는 상황이나 이유를 표현합니다.",
    additionalExplanation:
      "이런 분사구문의 경우 우선 읽고, 뒷문장을 읽음으로써 왜 언급되었는지 파악하면 됩니다. 마감일이 다가오는 것을 알고 그녀가 초과근무를 한 것을 알 수 있습니다. 처음부터 이것이 왜 쓰였는지 문법적으로 구분하는 것이 아닌, 우선 읽고, 왜 이 말을 했나 파악하는 순서로 독해해야 영어 어순대로 읽을 수 있습니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "부족한 것 충분한 자금이",
      "회사는",

      "연기했다",
      "그 회사의 확장 계획을",
    ],
    englishChunks: [
      "Lacking sufficient funds,",
      "the company",
      "postponed",
      "its expansion plan",
    ],
    fullEnglish:
      "Lacking sufficient funds, the company postponed its expansion plan.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Lacking'은 주절의 동작이 일어나게 된 원인이나 이유를 설명합니다.",
    additionalExplanation:
      "이런 분사구문의 경우 자금이 부족한 것을 언급 후, 뒤에서 회사가 계획을 연기한 것에서 자금이 부족한 것을 언급한 이유를 알 수 있습니다. 이런식으로 분사구문을 이해하도록 합니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "받지 않은 것 확인 이메일을",
      "그녀는",

      "연락했다",
      "고객 지원팀에",
    ],
    englishChunks: [
      "Not having received the confirmation email,",
      "she",
      "contacted",
      "customer support",
    ],
    fullEnglish:
      "Not having received the confirmation email, she contacted customer support.",
    explanation:
      "완료분사구문으로 이유를 나타냅니다. 'Not having received'는 주절의 동작이 일어나기 전에 발생한 상황을 표현합니다.",
    additionalExplanation:
      "이런 분사구문의 경우 확인 이메일을 받지 않은 것을 언급 후, 뒤에서 그녀가 고객 지원팀에 연락한 것에서 이메일을 받지 않은 것을 언급한 이유를 알 수 있습니다. 이런식으로 분사구문을 이해하도록 합니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "주어진 상승하는 생산 비용(을 고려해),",
      "경영진은",

      "결정했다",
      "올리기로 가격을",
    ],
    englishChunks: [
      "Given the rising production costs,",
      "management",
      "decided",
      "to increase prices",
    ],
    fullEnglish:
      "Given the rising production costs, management decided to increase prices.",
    explanation:
      "과거분사구문으로 조건이나 상황을 나타냅니다. 'Given'은 '~을 고려하여'의 의미로 사용되었습니다.",
    additionalExplanation:
      "이런 분사구문의 경우 상승하는 생산 비용을 언급 후, 뒤에서 경영진이 가격을 올리기로 결정한 것에서 생산 비용을 언급한 이유를 알 수 있습니다. 이런식으로 분사구문을 이해하도록 합니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "모르는것  마감일을",
      "지원자는",
      "제출했다",
      "서류를 늦게 ",
    ],
    englishChunks: [
      "Being unaware of the deadline,",
      "the applicant",
      "submitted",
      "the form late",
    ],
    fullEnglish:
      "Being unaware of the deadline, the applicant submitted the form late.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Being unaware'는 주절의 동작이 일어나게 된 원인을 설명합니다.",
    additionalExplanation:
      "이런 분사구문의 경우 마감일을 모르는 것을 언급 후, 뒤에서 지원자가 서류를 늦게 제출한 것에서 마감일을 모르는 것을 언급한 이유를 알 수 있습니다. 이런식으로 분사구문을 이해하도록 합니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "놓친것 조기 등록기간을,",
      "참가자들은",

      "내야 했다",
      "더 높은 수수료를",
    ],
    englishChunks: [
      "Having missed the early registration period,",
      "attendees",
      "had to pay",
      "a higher fee",
    ],
    fullEnglish:
      "Having missed the early registration period, attendees had to pay a higher fee.",
    explanation:
      "완료분사구문으로 이유를 나타냅니다. 'Having missed'는 주절의 동작이 일어나기 전에 발생한 상황을 표현합니다.",
    additionalExplanation: "놓친것 / 돈내야 하는것 -> 놓쳐서 돈내야 했다 ",
  },
  {
    id: 7,
    koreanChunks: [
      "훑어보는것 보고서를,",
      "그녀는",
      "발견했다",
      "몇 가지 불일치를",
    ],
    englishChunks: [
      "Glancing through the report,",
      "she",
      "noticed",
      "several discrepancies",
    ],
    fullEnglish:
      "Glancing through the report, she noticed several discrepancies.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Glancing'은 주절의 동작과 동시에 일어나는 행위를 표현합니다.",
    additionalExplanation: "훑어보는것 / 발견하는 것 -> 훑어보면서 발견함",
  },
  {
    id: 8,
    koreanChunks: [
      "들어가는 것 회의실 안으로,",
      "CEO는",
      "인사를 건넸다",
      "모든 직원들에게",
    ],
    englishChunks: [
      "Walking into the conference room,",
      "the CEO",
      "greeted",
      "all the employees",
    ],
    fullEnglish:
      "Walking into the conference room, the CEO greeted all the employees.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Walking'은 주절의 동작과 함께 일어나는 행위를 설명합니다.",
    additionalExplanation:
      "들어가는것 / 인사하는 것 ->  들어가면서 인사했다.  ",
  },
  {
    id: 9,
    koreanChunks: [
      "분류하는것 데이터들,",
      "분석가는",
      "파악했다",
      "중요한 트렌드를",
    ],
    englishChunks: [
      "Sorting through the data,",
      "the analyst",
      "identified",
      "critical trends",
    ],
    fullEnglish:
      "Sorting through the data, the analyst identified critical trends.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Sorting'은 주절의 동작과 동시에 진행되는 행위를 표현합니다.",
    additionalExplanation: "분류하는것 / 파악하는 것 -> 분류하면서 파악함 ",
  },
  {
    id: 10,
    koreanChunks: [
      "읽는것 계약서를 주의깊게,",
      "그는",
      "발견했다",
      "오류를",
      "합의서에서 ",
    ],
    englishChunks: [
      "Reading the contract carefully,",
      "he",
      "spotted",
      "an error",
      " in the agreement",
    ],
    fullEnglish:
      "Reading the contract carefully, he spotted an error in the agreement.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Reading'은 주절의 동작과 함께 일어나는 행위를 설명합니다.",
    additionalExplanation: "읽는것 / 발견하는 것 - 읽으면서 발견함 ",
  },
  {
    id: 11,
    koreanChunks: [
      "타이핑하는것 최종보고서를,",
      "그녀는",
      "두 번 확인했다",
      "숫자들을",
      "정확성을 위해",
    ],
    englishChunks: [
      "Typing the final report,",
      "she",
      "double-checked",
      "the figures",
      "for accuracy",
    ],
    fullEnglish:
      "Typing the final report, she double-checked the figures for accuracy.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Typing'은 주절의 동작과 동시에 진행되는 행위를 표현합니다.",
    additionalExplanation:
      "타이핑 하는것 / 두번 확인하는 것 -> 타이핑 하면서 두번 확인, 같이 일어남",
  },
  {
    id: 12,
    koreanChunks: [
      "제공된 적절한 훈련이,",
      "직원들은",
      "다룰 수 있다",
      "새로운 시스템을 효율적으로",
    ],
    englishChunks: [
      "Provided with proper training,",
      "employees",
      "can handle",
      "the new system efficiently",
    ],
    fullEnglish:
      "Provided with proper training, employees can handle the new system efficiently.",
    explanation:
      "과거분사구문으로 조건을 나타냅니다. 'Provided'는 'If (they are) provided'의 의미로 조건절을 표현합니다.",
    additionalExplanation:
      "적절한 훈련이 제공된 / 직원들은 할 수 있다 -> 앞외 제공된 상태를 언급했는지 알 수 있다.(제공되면)",
  },
  {
    id: 13,
    koreanChunks: [
      "가정하는것 모든 서류가 사인되는 걸,",
      "계약은",
      "발효될 것이다",
      "즉시",
    ],
    englishChunks: [
      "Assuming all documents are signed,",
      "the contract",
      "will take effect",
      "immediately",
    ],
    fullEnglish:
      "Assuming all documents are signed, the contract will take effect immediately.",
    explanation:
      "현재분사구문으로 조건을 나타냅니다. 'Assuming'은 'If we assume'의 의미로 가정을 표현합니다.",
    additionalExplanation:
      "가정하는 것 / 계약이 발효될 것이다 -> 가정하는 것은 말그대로 가정하는 상태로 뒷부분을 안읽어도 처음부터 가정하는 분사구문임을 알 수 있습니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "내버려둔 확인하지 않은 상태로,",
      "그 기술적 문제는",
      "초래할 수 있다",
      "심각한 혼란을",
    ],
    englishChunks: [
      "Left unchecked,",
      "the technical issue",
      "could cause",
      "severe disruptions",
    ],
    fullEnglish:
      "Left unchecked, the technical issue could cause severe disruptions.",
    explanation:
      "과거분사구문으로 조건을 나타냅니다. 'Left unchecked'는 'If it is left unchecked'의 의미를 함축합니다.",
    additionalExplanation:
      "확인하지 않은 상태로 둔 / 기술적 문제가 초래할 수 있다 -> 뒤 문장을 통해 왜 앞부분을 언급했는지 알 수 있다.(두면)",
  },
  {
    id: 15,
    koreanChunks: [
      "다뤄진 부적절하게,",
      "민감한 데이터가",
      "노출될 수 있다",
      "사이버 위협에",
    ],
    englishChunks: [
      "Handled improperly,",
      "sensitive data",
      "may be exposed",
      "to cyber threats",
    ],
    fullEnglish:
      "Handled improperly, sensitive data may be exposed to cyber threats.",
    explanation:
      "과거분사구문으로 조건을 나타냅니다. 'Handled improperly'는 'If it is handled improperly'의 의미입니다.",
    additionalExplanation:
      " 부적절하게 다뤄진 / 민감한 데이터가 노출될 수 있다 -> 이 뒷부분을 언급하면서 부적절하게 다뤄진걸 왜 언급했는지 알 수 있다.(다뤄지면)",
  },
  {
    id: 16,
    koreanChunks: [
      "주어진 충분한 자원,",
      "연구팀은",
      "(현재) 완료할 수 있을것이다",
      "프로젝트를 더 빨리",
    ],
    englishChunks: [
      "Given sufficient resources,",
      "the research team",
      "could complete",
      "the project faster",
    ],
    fullEnglish:
      "Given sufficient resources, the research team could complete the project faster.",
    explanation:
      "과거분사구문으로 조건을 나타냅니다. 'Given'은 'If (they are) given'의 의미로 조건절을 표현합니다.",
    additionalExplanation:
      "충분한 자원이 주어짐 / 완료할 수 있다 -> 뒷부분을 읽고 앞에 자원이 주어진걸 왜 언급했는지 알 수 있다 (주어진다면)",
  },
  {
    id: 17,
    koreanChunks: [
      "실패하는것 맞추는걸 안전기준을,",
      "그 제품은",
      "리콜되었다",
    ],
    englishChunks: [
      "Failing to meet the safety standards,",
      "the product",
      "was recalled",
    ],
    fullEnglish:
      "Failing to meet the safety standards, the product was recalled.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Failing to meet'는 '~하지 못했기 때문에'의 의미로 결과의 원인을 설명합니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "증가하는것 고객 수요,",
      "회사는",
      "확장했다",
      "그 회사의 생산 능력을",
    ],
    englishChunks: [
      "Increasing customer demand,",
      "the company",
      "expanded",
      "its production capacity",
    ],
    fullEnglish:
      "Increasing customer demand, the company expanded its production capacity.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Increasing'은 '증가하면서'라는 의미로 주절의 행동과 동시에 일어나는 상황을 설명합니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "초과하는것 기대치,",
      "마케팅 캠페인은",
      "창출했다",
      "기록적인 매출을",
    ],
    englishChunks: [
      "Exceeding expectations,",
      "the marketing campaign",
      "generated",
      "record sales",
    ],
    fullEnglish:
      "Exceeding expectations, the marketing campaign generated record sales.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Exceeding expectations'는 '기대치를 초과하면서'라는 의미로 주절의 행동과 함께 일어나는 상황을 설명합니다.",
    additionalExplanation:
      "기대치를 초과하는 것 / 창출했다 기록적 매출을 -> 기대치를 초과하며 기록적 매출을 창출",
  },
  {
    id: 20,
    koreanChunks: [
      "방치된 수년간,",
      "그 인프라는",
      "필요했다",
      "대대적인 수리가",
    ],
    englishChunks: [
      "Neglected for years,",
      "the infrastructure",
      "required",
      "major repairs",
    ],
    fullEnglish:
      "Neglected for years, the infrastructure required major repairs.",
    explanation:
      "과거분사구문으로 이유나 결과를 나타냅니다. 'Neglected for years'는 '수년간 방치되었기 때문에'라는 의미로 현재 상황의 원인을 설명합니다.",
    additionalExplanation:
      "수년간 방치된 / 필요했다 수리가 -> 수년간 방치되서 수리가 필요",
  },
  {
    id: 21,
    koreanChunks: [
      "실패하는것  다루는것을 고객의 불만들,",
      "그 브랜드는",
      "잃었다",
      "그 브랜드의 신뢰를",
    ],
    englishChunks: [
      "Failing to address customer complaints,",
      "the brand",
      "lost",
      "its credibility",
    ],
    fullEnglish:
      "Failing to address customer complaints, the brand lost its credibility.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Failing to address'는 '해결하지 못했기 때문에'라는 의미로 결과의 원인을 설명합니다.",
    additionalExplanation:
      "다루지 못함 고객의 불만을 / 브랜드가 잃음 신뢰를 -> 다루지 못해서 신뢰를 잃음",
  },
  {
    id: 22,
    koreanChunks: [
      "효율성을 위해 설계되었지만,",
      "그 새로운 소프트웨어는",
      "가지고 있다",
      "잦은 오류를",
    ],
    englishChunks: [
      "Though designed for efficiency,",
      "the new software",
      "has",
      "frequent glitches",
    ],
    fullEnglish:
      "Though designed for efficiency, the new software has frequent glitches.",
    explanation:
      "과거분사구문으로 양보를 나타냅니다. 'Though designed'는 '설계되었지만'이라는 의미로 예상과 다른 결과를 보여줍니다.",
  },
  {
    id: 23,
    koreanChunks: [
      "높은 자격을 갖추었음에도 불구하고,",
      "그녀는",
      "선정되지 않았다",
      "그 직책에",
    ],
    englishChunks: [
      "Despite being highly qualified,",
      "she",
      "was not selected",
      "for the position",
    ],
    fullEnglish:
      "Despite being highly qualified, she was not selected for the position.",
    explanation:
      "현재분사구문으로 양보를 나타냅니다. 'Despite being'은 '~임에도 불구하고'라는 의미로 예상과 다른 결과를 표현합니다.",
  },
  {
    id: 24,
    koreanChunks: ["완료한것 그 교육,", "직원들은", "배치되었다", "각 부서에"],
    englishChunks: [
      "Having completed the training,",
      "the employees",
      "were assigned",
      "to different departments",
    ],
    fullEnglish:
      "Having completed the training, the employees were assigned to different departments.",
    explanation:
      "완료분사구문으로 시간의 선후관계를 나타냅니다. 'Having completed'는 '~을 마친 후'라는 의미로 주절의 사건 이전에 일어난 일을 표현합니다.",
  },

  {
    id: 25,
    koreanChunks: ["제출한것 최종보고서를,", "그녀는", "냈다", "며칠 휴가를"],
    englishChunks: [
      "Having submitted the final report,",
      "she",
      "took",
      "a few days off",
    ],
    fullEnglish: "Having submitted the final report, she took a few days off.",
    explanation:
      "완료분사구문으로 시간의 선후관계를 나타냅니다. 'Having submitted'는 '~을 제출한 후'라는 의미로 주절의 행동 이전에 일어난 일을 표현합니다.",
    additionalExplanation:
      "제출했음 최종보거서 / 휴가를 냈다 -> 제출했고 , 휴가를 냈다",
  },
  {
    id: 26,
    koreanChunks: [
      "일을 한 것 그 업계에서 10년동안,",
      "그는",
      "승진했다",
      "매니저로",
    ],
    englishChunks: [
      "Having worked in the industry for over 10 years,",
      "he",
      "was promoted",
      "to manager",
    ],
    fullEnglish:
      "Having worked in the industry for over 10 years, he was promoted to manager.",
    explanation:
      "완료분사구문으로 시간의 선후관계를 나타냅니다. 'Having worked'는 '~동안 일한 후'라는 의미로 승진 이전의 경험을 표현합니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "놓친것 등록 마감일을,",
      "그녀는",
      "기다려야 했다",
      "다음 기회를",
    ],
    englishChunks: [
      "Having missed the registration deadline,",
      "she",
      "had to wait",
      "for the next session",
    ],
    fullEnglish:
      "Having missed the registration deadline, she had to wait for the next session.",
    explanation:
      "완료분사구문으로 인과관계를 나타냅니다. 'Having missed'는 '~을 놓친 후'라는 의미로 결과의 원인을 설명합니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "검토한것 계약서를,",
      "변호사는",
      "제안했다",
      "몇 가지 수정을",
    ],
    englishChunks: [
      "Having reviewed the contract,",
      "the lawyer",
      "suggested",
      "several changes",
    ],
    fullEnglish:
      "Having reviewed the contract, the lawyer suggested several changes.",
    explanation:
      "완료분사구문으로 시간의 선후관계를 나타냅니다. 'Having reviewed'는 '~을 검토한 후'라는 의미로 제안 이전에 일어난 검토 행위를 표현합니다.",
  },
  {
    id: 29,
    koreanChunks: ["회의가 끝난것,", "직원들은", "돌아갔다", "그들의 자리로"],
    englishChunks: [
      "The meeting having ended,",
      "the employees",
      "returned",
      "to their desks",
    ],
    fullEnglish:
      "The meeting having ended, the employees returned to their desks.",
    explanation:
      "완료분사구문으로 시간의 선후관계를 나타냅니다. 'having ended'는 '~이 끝나자'라는 의미로 직원들이 돌아가기 전에 일어난 회의 종료를 표현합니다.",
  },
  {
    id: 30,
    koreanChunks: ["날씨 예측불가한,", "그 행사는", "연기되었다"],
    englishChunks: [
      "The weather being unpredictable,",
      "the event",
      "was postponed",
    ],
    fullEnglish: "The weather being unpredictable, the event was postponed.",
    explanation:
      "현재분사구문으로 인과관계를 나타냅니다. 'being unpredictable'은 '~이 변덕스러워서'라는 의미로 행사 연기의 원인을 설명합니다.",
  },
  {
    id: 31,
    koreanChunks: [
      "CEO 사임한,",
      "회사는",
      "시작했다",
      "찾는것을",
      "대체를 위해",
    ],
    englishChunks: [
      "The CEO having resigned,",
      "the company",
      "began",
      "searching",
      "for a replacement",
    ],
    fullEnglish:
      "The CEO having resigned, the company began searching for a replacement.",
    explanation:
      "완료분사구문으로 시간의 선후관계를 나타냅니다. 'having resigned'는 '~이 사임하자'라는 의미로 후임자 검색 이전에 일어난 사임을 표현합니다.",
  },
  {
    id: 32,
    koreanChunks: [
      "프로젝트 스케줄보다 앞선,",
      "그 팀은",
      "결정했다",
      "갖기로 짧은 휴식을",
    ],
    englishChunks: [
      "The project being ahead of schedule,",
      "the team",
      "decided",
      " to take a short break",
    ],
    fullEnglish:
      "The project being ahead of schedule, the team decided to take a short break.",
    explanation:
      "현재분사구문으로 인과관계를 나타냅니다. 'being ahead of schedule'은 '~이 예상보다 앞서 진행되자'라는 의미로 휴식 결정의 원인을 설명합니다.",
  },
  {
    id: 33,
    koreanChunks: ["모든 티겟 매진된,", "많은 고객들이", "실망했다"],
    englishChunks: [
      "All tickets having been sold out,",
      "many customers",
      "were disappointed",
    ],
    fullEnglish:
      "All tickets having been sold out, many customers were disappointed.",
    explanation:
      "완료분사구문으로 인과관계를 나타냅니다. 'having been sold out'은 '~이 매진되자'라는 의미로 고객들의 실망 원인을 설명합니다.",
  },
  {
    id: 34,
    koreanChunks: [
      "모르는것 어디서 찾을지 보고서를,",
      "그는",
      "물어봤다",
      "그의 동료에게",
    ],
    englishChunks: [
      "Wondering where to find the report,",
      "he",
      "asked",
      "his colleague",
    ],
    fullEnglish: "Wondering where to find the report, he asked his colleague.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Wondering'은 '~을 궁금해하면서/몰라서'라는 의미로 동료에게 물어본 이유를 설명합니다.",
  },
  {
    id: 35,
    koreanChunks: [
      "생각하는것 언제 런칭할지 새 제품을,",
      "팀은",
      "진행했다",
      "시장 조사를",
    ],
    englishChunks: [
      "Thinking about when to launch the new product,",
      "the team",
      "conducted",
      "market research",
    ],
    fullEnglish:
      "Thinking about when to launch the new product, the team conducted market research.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Thinking about'은 '~에 대해 고민하면서'라는 의미로 시장 조사와 함께 일어난 행동을 설명합니다.",
  },
  {
    id: 36,
    koreanChunks: [
      "고민되는 어떻게 향상시킬지 효율성을,",
      "매니저는",
      "실행했다",
      "새로운 전략을",
    ],
    englishChunks: [
      "Concerned about how to improve efficiency,",
      "the manager",
      "implemented",
      "new strategies",
    ],
    fullEnglish:
      "Concerned about how to improve efficiency, the manager implemented new strategies.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Concerned about'는 '~에 대해 걱정하면서/고민하면서'라는 의미로 새로운 전략을 실행하게 된 배경을 설명합니다.",
  },
  {
    id: 37,
    koreanChunks: [
      "압박감받는 어떻게 해결할지 이 상황을(그래서),",
      "그 팀은",
      "찾았다",
      "전문가의 조언을",
    ],
    englishChunks: [
      "Overwhelmed by how to handle the situation,",
      "the team",
      "sought",
      "expert advice",
    ],
    fullEnglish:
      "Overwhelmed by how to handle the situation, the team sought expert advice.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Overwhelmed by'는 '~에 압도되어/어려워서'라는 의미로 전문가의 조언을 구하게 된 이유를 설명합니다.",
  },
  {
    id: 38,
    koreanChunks: [
      "생각하는 것 언제 제출할지 제안서를,",
      "그녀는",
      "검토했다",
      "세부 사항을",
    ],
    englishChunks: [
      "Thinking about when to submit the proposal,",
      "she",
      "reviewed",
      "the details",
    ],
    fullEnglish:
      "Thinking about when to submit the proposal, she reviewed the details.",
    explanation:
      "현재분사구문으로 동시동작을 나타냅니다. 'Thinking about'은 '~에 대해 고민하면서'라는 의미로 세부 사항을 검토하는 것과 동시에 일어난 행동을 설명합니다.",
  },
  {
    id: 39,
    koreanChunks: ["깨닫지 못하는것  중요성 회의,", "그는", "도착했다", "늦게"],
    englishChunks: [
      "Not realizing the importance of the meeting,",
      "he",
      "arrived",
      "late",
    ],
    fullEnglish:
      "Not realizing the importance of the meeting, he arrived late.",
    explanation:
      "현재분사구문으로 이유를 나타냅니다. 'Not realizing'은 '깨닫지 못하고'라는 의미로 늦게 도착하게 된 이유를 설명합니다.",
  },
  {
    id: 40,
    koreanChunks: [
      "가정하는 것 모든 요건이 충족됨을 ",
      "계약은",
      "체결될 것이다",
      "다음 주에",
    ],
    englishChunks: [
      "Assuming all requirements are met,",
      "the contract",
      "will be signed",
      "next week",
    ],
    fullEnglish:
      "Assuming all requirements are met, the contract will be signed next week.",
    explanation:
      "현재분사구문으로 조건을 나타냅니다. 'Assuming'은 '~라고 가정하면'이라는 의미로 계약이 체결될 조건을 설명합니다.",
  },
  {
    id: 41,
    koreanChunks: [
      "그 프로젝트는 어려웠다.",
      "그렇긴 하지만,",
      "우리는",

      "완료해냈다 그 프로젝트를(it)",
      "제시간에",
    ],
    englishChunks: [
      "The project was challenging.",
      "Having said that,",
      "we",
      "managed to complete it",
      "on time",
    ],
    fullEnglish:
      "The project was challenging. Having said that, we managed to complete it on time.",
    explanation:
      "현재완료분사구문 'Having said that'은 '그렇긴 하지만'이라는 의미로 앞 문장의 내용을 인정하면서도 뒤에 이어질 반대되는 내용을 연결하는 역할을 합니다.",
  },
  {
    id: 42,
    koreanChunks: [
      "새로운 정책을 시행하는 것뿐만 아니라,",
      "회사는",
      "개선하고 있다",
      "직원 복지를",
    ],
    englishChunks: [
      "In addition to implementing new policies,",
      "the company",
      "is improving",
      "employee benefits",
    ],
    fullEnglish:
      "In addition to implementing new policies, the company is improving employee benefits.",
    explanation:
      "현재분사구문 'In addition to implementing'은 '~하는 것뿐만 아니라'라는 의미로 회사가 하고 있는 추가적인 활동을 나타냅니다. 전치사 'in addition to' 뒤에는 동명사가 사용됩니다.",
  },
  {
    id: 43,
    koreanChunks: [
      "경쟁력있는 급여를 제공하는것 뿐만 아니라,  ",
      "회사는",
      "제공한다",
      "우수한 교육 프로그램도",
    ],
    englishChunks: [
      "In addition to offering competitive salaries,",
      "the company",
      "provides",
      "excellent training programs",
    ],
    fullEnglish:
      "In addition to offering competitive salaries, the company provides excellent training programs.",
    explanation:
      "현재분사구문 'In addition to offering'은 '~하는 것뿐만 아니라'라는 의미로 회사가 제공하는 추가적인 혜택을 나타냅니다. 전치사 'in addition to' 뒤에는 동명사가 사용됩니다.",
  },
];
